import React from 'react';

import SEO from '../../SEO';
import UhOh from '../../ui/UhOh';
import Button from '../../ui/Button';
import { UhOhPage } from './UhOhPage';
import Header from '$/sections/Home/Header';

export const ErrorBoundaryView: React.FC<{
  error: Error;
  info: React.ErrorInfo;
  clearError: () => void;
}> = () => (
  <UhOhPage>
    <SEO title='500 Something went wrong' />

    <Header />

    <UhOh.Container>
      <UhOh.Title>Oops...</UhOh.Title>
      <UhOh.Body>
        Looks like we’ve run into an issue.
        <p />
        Please refresh the page and let us know what you were doing when you encountered this
        problem. We’re looking into it...
      </UhOh.Body>
      <Button.rounded
        className='w-10e h-2e text-2xl'
        onClick={(): void => {
          location.reload();
        }}
      >
        Refresh
      </Button.rounded>
    </UhOh.Container>
  </UhOhPage>
);
